// Resolve + format the patient's date of birth. Withings birthdate is epoch
// SECONDS; member / insurance sources may be ISO. UTC throughout so it can't drift.

interface PatientDobLike { birthdate?: number | string | null }
interface DetailsDobLike {
  birthdate?: number | string | null;
  member?: { birthdate?: number | string | null } | null;
}
interface InsuranceDobLike { cardholder_dob?: string | null }

export interface Birthdate { iso: string; display: string; age: number | null }

function toDate(raw: number | string | null | undefined): Date | null {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) { // already ISO
    const d = new Date(`${s.slice(0, 10)}T00:00:00Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (/^-?\d+$/.test(s)) { // epoch seconds
    const d = new Date(Number(s) * 1000);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

function ageFrom(d: Date): number | null {
  const now = new Date();
  let age = now.getUTCFullYear() - d.getUTCFullYear();
  const m = now.getUTCMonth() - d.getUTCMonth();
  if (m < 0 || (m === 0 && now.getUTCDate() < d.getUTCDate())) age -= 1;
  return age >= 0 && age < 130 ? age : null;
}

export function resolveBirthdate(
  patient?: PatientDobLike | null,
  patientDetails?: DetailsDobLike | null,
  insurance?: InsuranceDobLike | null,
): Birthdate | null {
  const d = toDate(
    patient?.birthdate
    ?? patientDetails?.member?.birthdate
    ?? patientDetails?.birthdate
    ?? insurance?.cardholder_dob
    ?? null,
  );
  if (!d) return null;
  return {
    iso: d.toISOString().slice(0, 10),
    display: d.toLocaleDateString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC',
    }),
    age: ageFrom(d),
  };
}
